import $ from 'jquery'
import Splide from '@splidejs/splide'
import algoliasearch from 'algoliasearch/lite'
import { algoliaApiKey, algoliaAppId, placeSearchIndex } from '../variables'
import aa from 'search-insights';

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
const searchIndex = searchClient.initIndex(placeSearchIndex)

// eslint-disable-next-line no-undef
const object = vnObject
const splideOptions = {
    drag: 'free',
    pagination: false,
    perPage: 4,
    autoHeight: true,
    gap: '30px',
    breakpoints: {
        992: {
            perPage: 3,
            arrows: false,
        },
        768: {
            fixedWidth: '210px',
            perPage: 1,
            gap: '20px',
        },
    },
}

$('.places-block').each(function () {
    let manual_selection = $(this).data('manual_selection')
    if (manual_selection === 1) {
        let placesSplide = new Splide(
            $('.js-places-slider', this)[0],
            splideOptions
        )
        placesSplide.mount()
        return
    }
    let b_place_category = $(this).data('place_category')
    let b_place_type = $(this).data('place_type')
    let lat_lng = $(this).data('lat_lng')
    let algolia_polygon = $(this).data('algolia_polygon')
    let requestOptions = {
        hitsPerPage: 10,
    }
    if (algolia_polygon && algolia_polygon.length > 0) {
        requestOptions.insidePolygon = algolia_polygon
    }
    else {
        requestOptions.aroundLatLng = lat_lng
        if ( ! $('body').hasClass('home') ) {
            requestOptions.aroundRadius = eval(object.defaultRadius * 1000)
        }
    }

    requestOptions.facetFilters = [];

// Vérifier si b_place_category est défini
    if (b_place_category) {
        requestOptions.facetFilters.push(
            `placeCategory.objectID:${parseInt(b_place_category, 10)}`
        );
    }

// Vérifier si b_place_type est défini
    if (b_place_type) {
        requestOptions.facetFilters.push(
            `placeType.objectID:${parseInt(b_place_type, 10)}`
        );
    }

    searchIndex
        .search('', requestOptions)
        .then(({ hits }) => {
            if (hits.length === 0) {
                // Aucune donnée trouvée
                $(this).remove()
                return
            }
            let slidesHtml = ''

            hits.forEach((hit) => {
                let imageUrl = hit.images && hit.images.cards ? hit.images.cards : null

                slidesHtml += `
              <article class="splide__slide feed-place" id="feed-place-${
                    hit.objectID
                }" data-id="${hit.objectID}">
                <a id="feed-place-url-${
                    hit.objectID
                }" href="${hit.url}" title="${hit.title}" class="feed-place__wrapper gtm_place_feed_visible gtm_place_feed_clicks">
                  ${
                    imageUrl
                        ? `<img src="${imageUrl}" class="feed-place__img" alt="${hit.title}">`
                        : `<img src="${object.placesDefaultImage}" class="feed-place__img" alt="Default Image">`
                }
                  <div class="feed-place__contents">
                    <span class="feed-place__title">
                      ${hit.title}
                    </span>
                    <span class="feed-place__address">
                      ${hit.zipCode ? hit.zipCode : ''}${
                    hit.city ? ', ' + hit.city : ''
                }
                    </span>
                  </div>
                </a>
              </article>
          `
            })

            // Inject slider HTML into the DOM
            $('.splide__list', this).html(slidesHtml)
            // eslint-disable-next-line

            $('.feed-place').on('click', function (e) {
                aa('sendEvents', [
                    {
                        eventType: 'click',
                        eventName: 'Place Clicked',
                        index: placeSearchIndex,
                        objectIDs: [$(this).data('id').toString()],
                    },
                ]);
            })

            let placesSplide = new Splide($('.js-places-slider', this)[0], splideOptions)
            placesSplide.mount()
        })
        .catch((err) => {
            console.error(err)
        })
})

